module.exports = __webpack_public_path__ + "static/physical-mental-health-cec217f1bdd835417c4b4b6e73117070.jpg";